import { LayoutGrid } from "lucide-react";
import clsx from "clsx";
import { useDashboardStore, VALID_COUNTS, type ChartCount } from "@/store/dashboard";

export function ChartCountSelector() {
  const count = useDashboardStore((s) => s.count);
  const setCount = useDashboardStore((s) => s.setCount);

  return (
    <div className="flex items-center gap-1.5">
      <LayoutGrid className="h-3.5 w-3.5 text-text-muted" />
      <span className="text-2xs uppercase tracking-wider text-text-muted">Charts</span>
      <div className="flex items-center gap-px rounded-md border border-border bg-bg-panel p-0.5">
        {VALID_COUNTS.map((n) => (
          <button
            key={n}
            onClick={() => setCount(n as ChartCount)}
            className={clsx(
              "min-w-[26px] rounded px-2 py-0.5 font-mono text-xs font-semibold transition-colors",
              count === n
                ? "bg-accent text-white"
                : "text-text-secondary hover:bg-bg-hover hover:text-text-primary"
            )}
            title={`${n} chart${n === 1 ? "" : "s"}`}
          >
            {n}
          </button>
        ))}
      </div>
    </div>
  );
}
